import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5992990c")

_pushScopeId("data-v-5992990c")
const _hoisted_1 = {
  class: "cont_seond",
  style: {"width":"1720px","margin":"0 auto"}
}
const _hoisted_2 = { class: "custom-tabs-label" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "测试记录", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("全部清空")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("导出勾选数据")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除勾选数据")
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "查看问题汇总", -1)
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_11 = {
  class: "spacName",
  style: {"display":"flex","justify-content":"flex-end"}
}
const _hoisted_12 = { class: "dialogForm" }
const _hoisted_13 = { class: "dialogTitle" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "上传性能数据", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "el-icon-upload" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" 将文件拖到此处，或 "),
  /*#__PURE__*/_createVNode("em", null, "点击上传")
], -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "el-upload__tip" }, " 只能上传excel文件，且不超过50MB ", -1)
const _hoisted_18 = { class: "dialog-footer" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("重 置")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("确 定")
const _hoisted_21 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_22 = { style: {"vertical-align":"middle","margin-bottom":"0"} }
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "subTitle spacName" }, "◆", -1)
const _hoisted_24 = { class: "gameTable_cpu" }
const _hoisted_25 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, "字段名"),
    /*#__PURE__*/_createVNode("td", null, "通过的判定取值"),
    /*#__PURE__*/_createVNode("td", null, "不通过的判定取值")
  ])
], -1)
const _hoisted_26 = { style: {"padding":"6px 0"} }
const _hoisted_27 = { style: {"box-sizing":"border-box","padding":"6px","width":"42.5%"} }
const _hoisted_28 = { style: {"box-sizing":"border-box","padding":"6px","width":"42.5%"} }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/_createVNode("h6", { style: {"vertical-align":"middle","margin-bottom":"0"} }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle spacName" }, "◆"),
  /*#__PURE__*/_createTextVNode("性能基线 ")
], -1)
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/_createVNode("h6", { style: {"vertical-align":"middle","margin-bottom":"0"} }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle spacName" }, "◆"),
  /*#__PURE__*/_createTextVNode("画质基线 ")
], -1)
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_38 = {
  key: 1,
  style: {"font-size":"14px","color":"#c0c4cc","widht":"100%"}
}
const _hoisted_39 = /*#__PURE__*/_createTextVNode("配置全部")
const _hoisted_40 = { class: "dialogForm" }
const _hoisted_41 = { class: "dialogTitle" }
const _hoisted_42 = /*#__PURE__*/_createVNode("span", null, "文件上传", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("i", { class: "el-icon-upload" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" 将文件拖到此处，或 "),
  /*#__PURE__*/_createVNode("em", null, "点击上传")
], -1)
const _hoisted_45 = /*#__PURE__*/_createVNode("div", { class: "el-upload__tip" }, " 只能上传excel文件，且不超过50MB ", -1)
const _hoisted_46 = { class: "dialog-footer" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode("重 置")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("确 定")
const _hoisted_49 = { class: "dj" }
const _hoisted_50 = /*#__PURE__*/_createVNode("span", null, "提交BUG单", -1)
const _hoisted_51 = { class: "dialog-footer" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_53 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_54 = /*#__PURE__*/_createVNode("span", null, "提交BUG单", -1)
const _hoisted_55 = { class: "dialog-footer" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_57 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_58 = /*#__PURE__*/_createTextVNode("一键提单")
const _hoisted_59 = { key: 0 }
const _hoisted_60 = {
  key: 1,
  style: {"color":"green"}
}
const _hoisted_61 = {
  class: "spacName",
  style: {"display":"flex","justify-content":"flex-end"}
}
const _hoisted_62 = { class: "editRecipient" }
const _hoisted_63 = { style: {"display":"flex"} }
const _hoisted_64 = /*#__PURE__*/_createTextVNode("创建")
const _hoisted_65 = /*#__PURE__*/_createTextVNode("恢复默认")
const _hoisted_66 = { style: {"margin":"20px 0"} }
const _hoisted_67 = { class: "dialogTitle" }
const _hoisted_68 = /*#__PURE__*/_createVNode("span", null, "新增项目", -1)
const _hoisted_69 = { class: "dialog-footer" }
const _hoisted_70 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_71 = /*#__PURE__*/_createTextVNode("确 认")
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { key: 1 }
const _hoisted_74 = {
  class: "spacName",
  style: {"display":"flex","justify-content":"flex-end"}
}
const _hoisted_75 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_76 = { class: "dialogTitle" }
const _hoisted_77 = /*#__PURE__*/_createVNode("span", null, "上传数据", -1)
const _hoisted_78 = /*#__PURE__*/_createTextVNode("+")
const _hoisted_79 = /*#__PURE__*/_createVNode("i", { class: "el-icon-upload" }, null, -1)
const _hoisted_80 = /*#__PURE__*/_createVNode("em", null, "点击上传", -1)
const _hoisted_81 = { class: "dialog-footer" }
const _hoisted_82 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_83 = /*#__PURE__*/_createTextVNode("确 认")
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = {
  class: "spacName",
  style: {"display":"flex","justify-content":"flex-end"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_calendar = _resolveComponent("calendar")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option_group = _resolveComponent("el-option-group")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_progress = _resolveComponent("el-progress")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_QuillEditor = _resolveComponent("QuillEditor")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode(_component_el_tabs, {
                  modelValue: _ctx.activeName,
                  "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => (_ctx.activeName = $event)),
                  type: "card",
                  onTabClick: _ctx.handleClick
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_tab_pane, { name: "first" }, {
                      label: _withId(() => [
                        _createVNode("span", _hoisted_2, [
                          _createVNode(_component_el_icon, null, {
                            default: _withId(() => [
                              _createVNode(_component_calendar)
                            ]),
                            _: 1
                          }),
                          _hoisted_3
                        ])
                      ]),
                      default: _withId(() => [
                        _createVNode(_component_el_card, null, {
                          default: _withId(() => [
                            _createVNode("div", null, [
                              _createVNode("span", {
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submitUpload('open'))),
                                style: {"font-size":"14px","color":"#409eff","widht":"100%","cursor":"pointer"}
                              }, "上传性能数据"),
                              _createVNode(_component_el_card, { class: "spacName" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_form, {
                                    class: "spacForm",
                                    size: "mini",
                                    inline: true
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_form_item, { label: "选择项目" }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_select, {
                                            modelValue: _ctx.form.project,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.project = $event)),
                                            placeholder: "请选择项目",
                                            clearable: "",
                                            filterable: "",
                                            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectTableChange('project')))
                                          }, {
                                            default: _withId(() => [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.projectList, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.project_name,
                                                  label: item.project__project_name,
                                                  value: item.project_name
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_form_item, { label: "选择标签" }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_select, {
                                            modelValue: _ctx.form.label,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.label = $event)),
                                            placeholder: "请选择标签",
                                            clearable: "",
                                            filterable: "",
                                            "collapse-tags": "",
                                            "collapse-tags-tooltip": "",
                                            multiple: "",
                                            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectTableChange('Search')))
                                          }, {
                                            default: _withId(() => [
                                              _createVNode(_component_el_option_group, null, {
                                                default: _withId(() => [
                                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tagList, (item) => {
                                                    return (_openBlock(), _createBlock(_component_el_option, {
                                                      key: item.label_name,
                                                      label: item.label_name,
                                                      value: item.label_name
                                                    }, null, 8, ["label", "value"]))
                                                  }), 128))
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_form_item, { label: "选择机型" }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_select, {
                                            modelValue: _ctx.form.model,
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.model = $event)),
                                            placeholder: "请选择机型",
                                            clearable: "",
                                            filterable: "",
                                            "collapse-tags": "",
                                            "collapse-tags-tooltip": "",
                                            multiple: "",
                                            onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectTableChange('Search')))
                                          }, {
                                            default: _withId(() => [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modelList, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.model,
                                                  label: item.chinese,
                                                  value: item.model
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_form_item, { label: "选择档位" }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_select, {
                                            modelValue: _ctx.form.level,
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.level = $event)),
                                            placeholder: "请选择档位",
                                            clearable: "",
                                            onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectTableChange('Search')))
                                          }, {
                                            default: _withId(() => [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.levelList, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.level,
                                                  label: item.chinese,
                                                  value: item.level
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_form_item, { label: "选择测试人员" }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_select, {
                                            modelValue: _ctx.form.tester,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.tester = $event)),
                                            placeholder: "请选择测试人员",
                                            clearable: "",
                                            onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectTableChange('Search')))
                                          }, {
                                            default: _withId(() => [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.testerList, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.tester,
                                                  label: item.tester,
                                                  value: item.tester
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_form_item, null, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_button, {
                                            type: "primary",
                                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onTableClear()))
                                          }, {
                                            default: _withId(() => [
                                              _hoisted_4
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_form_item, null, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_button, {
                                            type: "primary",
                                            onClick: _ctx.downloadCsv
                                          }, {
                                            default: _withId(() => [
                                              _hoisted_5
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_form_item, null, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_button, {
                                            type: "primary",
                                            onClick: _ctx.deleteData
                                          }, {
                                            default: _withId(() => [
                                              _hoisted_6
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _withDirectives(_createVNode(_component_el_table, {
                                    onSelectionChange: _ctx.handleCheck,
                                    data: _ctx.get_all_performance,
                                    ref: "dataTable",
                                    "header-cell-class-name": "tabelHeader"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_table_column, {
                                        index: _ctx.indexMethod(0),
                                        type: "index",
                                        label: "序号",
                                        width: "60"
                                      }, null, 8, ["index"]),
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PerfFields, (item, index) => {
                                        return (_openBlock(), _createBlock(_component_el_table_column, {
                                          key: item.label,
                                          index: index,
                                          width: item.width,
                                          label: item.label,
                                          prop: item.prop,
                                          title: item.prop,
                                          "show-overflow-tooltip": true
                                        }, {
                                          default: _withId((scope) => [
                                            _createTextVNode(_toDisplayString(scope.row[item.prop] ? scope.row[item.prop] : "-"), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["index", "width", "label", "prop", "title"]))
                                      }), 128)),
                                      _createVNode(_component_el_table_column, {
                                        "label-class-name": "DisabledSelection",
                                        type: "selection",
                                        label: "有效",
                                        width: "60",
                                        fixed: "right"
                                      }, {
                                        default: _withId((scope) => [
                                          _createVNode(_component_el_checkbox, {
                                            modelValue: scope.row.is_check,
                                            "onUpdate:modelValue": ($event: any) => (scope.row.is_check = $event),
                                            onChange: ($event: any) => (_ctx.checkChange(scope.row))
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "查看子标签",
                                        width: "100",
                                        fixed: "right"
                                      }, {
                                        default: _withId((scope) => [
                                          _createVNode("a", {
                                            style: {"color":"rgb(64, 158, 255)","cursor":"pointer"},
                                            onClick: ($event: any) => (_ctx.handleDetail(scope.row))
                                          }, "查看", 8, ["onClick"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["onSelectionChange", "data"]), [
                                    [_directive_loading, _ctx.loading]
                                  ]),
                                  _createVNode(_component_el_dialog, {
                                    modelValue: _ctx.dialogVisible4,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.dialogVisible4 = $event)),
                                    width: "30%",
                                    onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.dialogVisible4 = false)),
                                    style: {"padding":"0"}
                                  }, {
                                    title: _withId(() => [
                                      _hoisted_7
                                    ]),
                                    footer: _withId(() => [
                                      _createVNode("span", _hoisted_8, [
                                        _createVNode(_component_el_button, {
                                          size: "small",
                                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.dialogVisible4 = false))
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_9
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_button, {
                                          size: "small",
                                          type: "primary",
                                          onClick: _ctx.handleDetailProblem
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_10
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ])
                                    ]),
                                    default: _withId(() => [
                                      _createVNode(_component_el_form, {
                                        size: "small",
                                        inline: true,
                                        "label-position": "top"
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_form_item, { label: "基线列表" }, {
                                            default: _withId(() => [
                                              _createVNode(_component_el_select, {
                                                onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.lineChange())),
                                                modelValue: _ctx.basic_value,
                                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.basic_value = $event)),
                                                placeholder: "请选择",
                                                clearable: ""
                                              }, {
                                                default: _withId(() => [
                                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.top_base_list, (item) => {
                                                    return (_openBlock(), _createBlock(_component_el_option, {
                                                      key: item.id,
                                                      label: item.project_name,
                                                      value: item.id
                                                    }, null, 8, ["label", "value"]))
                                                  }), 128))
                                                ]),
                                                _: 1
                                              }, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]),
                                  _createVNode("div", _hoisted_11, [
                                    _createVNode(_component_el_form, {
                                      inline: true,
                                      size: "mini",
                                      style: {"display":"flex","align-items":"center"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_form_item, null, {
                                          default: _withId(() => [
                                            _createVNode("a", {
                                              style: {"color":"rgb(64, 158, 255)","cursor":"pointer"},
                                              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.dialogVisible4 = true))
                                            }, "查看问题汇总")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_form_item, { label: "每页" }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: _ctx.record,
                                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.record = $event)),
                                              style: {"width":"55px","height":"28px"},
                                              onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.selectTableChange('paging')))
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_form_item, { label: "条记录" }),
                                        _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_pagination, {
                                              onCurrentChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.selectTableChange('paging'))),
                                              currentPage: _ctx.current_page,
                                              "onUpdate:currentPage": _cache[22] || (_cache[22] = ($event: any) => (_ctx.current_page = $event)),
                                              "page-size": _ctx.record,
                                              layout: "total, prev, pager, next, jumper",
                                              total: _ctx.readPerformancePageList.count
                                            }, null, 8, ["currentPage", "page-size", "total"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode("div", _hoisted_12, [
                                    _createVNode(_component_el_dialog, {
                                      modelValue: _ctx.dialogVisible,
                                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.dialogVisible = $event)),
                                      width: "30%",
                                      onClose: _cache[28] || (_cache[28] = ($event: any) => (_ctx.dialogVisible = false))
                                    }, {
                                      title: _withId(() => [
                                        _createVNode("div", _hoisted_13, [
                                          _hoisted_14,
                                          _createVNode(_component_el_divider)
                                        ])
                                      ]),
                                      footer: _withId(() => [
                                        _createVNode("span", _hoisted_18, [
                                          _createVNode(_component_el_button, {
                                            size: "small",
                                            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.submitUpload('no')))
                                          }, {
                                            default: _withId(() => [
                                              _hoisted_19
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_button, {
                                            size: "small",
                                            type: "primary",
                                            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.submitUpload('ok')))
                                          }, {
                                            default: _withId(() => [
                                              _hoisted_20
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      default: _withId(() => [
                                        _createVNode(_component_el_form, {
                                          model: _ctx.dialogForm,
                                          size: "small",
                                          "label-position": "top"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_form_item, { label: "项目" }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_input, {
                                                  style: {"width":"150px"},
                                                  modelValue: _ctx.dialogForm1.project,
                                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.dialogForm1.project = $event)),
                                                  placeholder: "请输入"
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_form_item, { label: "PerfDog链接" }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_input, {
                                                  modelValue: _ctx.dialogForm1.url,
                                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.dialogForm1.url = $event)),
                                                  placeholder: "请输入"
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_form_item, { label: "上传文件" }, {
                                              default: _withId(() => [
                                                _createVNode(_component_el_upload, {
                                                  class: "upload-demo",
                                                  drag: "",
                                                  action: "http://127.0.0.1:8081/api/v1/performance/top_perdog_upload/",
                                                  multiple: "",
                                                  limit: 10,
                                                  "before-remove": _ctx.beforeRemove,
                                                  "before-upload": _ctx.beforeUpload,
                                                  ref: 'upload',
                                                  "http-request": _ctx.UploadFile,
                                                  "file-list": _ctx.fileList1
                                                }, {
                                                  tip: _withId(() => [
                                                    _hoisted_17
                                                  ]),
                                                  default: _withId(() => [
                                                    _hoisted_15,
                                                    _hoisted_16
                                                  ]),
                                                  _: 1
                                                }, 8, ["before-remove", "before-upload", "http-request", "file-list"]),
                                                (_ctx.progressFlag)
                                                  ? (_openBlock(), _createBlock(_component_el_progress, {
                                                      key: 0,
                                                      percentage: _ctx.loadProgress
                                                    }, null, 8, ["percentage"]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["model"])
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ])
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tab_pane, {
                      label: "基线配置",
                      style: {"width":"50%；margin:auto"},
                      name: "second",
                      disabled: false
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_card, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_form, {
                              inline: true,
                              "label-position": "left",
                              size: "mini"
                            }, {
                              default: _withId(() => [
                                _createVNode("div", _hoisted_21, [
                                  _createVNode("div", null, [
                                    _createVNode(_component_el_form_item, { label: "基线列表" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          onChange: _cache[29] || (_cache[29] = ($event: any) => (_ctx.lineChange())),
                                          modelValue: _ctx.basic_value,
                                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.basic_value = $event)),
                                          placeholder: "请选择",
                                          clearable: ""
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.top_base_list, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.id,
                                                label: item.project_name,
                                                value: item.id
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode("div", null, [
                                    _createVNode(_component_el_form_item, { label: "基线名" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.configuration_name,
                                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.configuration_name = $event)),
                                          disabled: _ctx.configurationShow
                                        }, null, 8, ["modelValue", "disabled"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_button, {
                                          type: _ctx.configurationShow ? 'primary' : 'success',
                                          onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.editConfigurationShow()))
                                        }, {
                                          default: _withId(() => [
                                            _createTextVNode(_toDisplayString(_ctx.configurationShow ? "编辑" : "保存"), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["type"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.createConfiguration()))
                                        }, {
                                          default: _withId(() => [
                                            _createTextVNode(_toDisplayString(_ctx.configurationShow ? "创建" : "取消"), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ]),
                              _: 1
                            }),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.baseline_data, (item) => {
                              return (_openBlock(), _createBlock("div", { key: item }, [
                                _createVNode("h6", _hoisted_22, [
                                  _hoisted_23,
                                  _createTextVNode(_toDisplayString(item.name), 1)
                                ]),
                                _createVNode("table", _hoisted_24, [
                                  _hoisted_25,
                                  _createVNode("tbody", null, [
                                    _createVNode("tr", null, [
                                      _createVNode("td", _hoisted_26, _toDisplayString(item.name), 1),
                                      _createVNode("td", _hoisted_27, [
                                        _createVNode("span", null, [
                                          (_ctx.configurationShow)
                                            ? (_openBlock(), _createBlock("span", {
                                                key: 0,
                                                onClick: ($event: any) => (_ctx.editOpen(item.name, 'pass', 0))
                                              }, _toDisplayString(item.pass_text), 9, ["onClick"]))
                                            : _createCommentVNode("", true),
                                          (!_ctx.configurationShow)
                                            ? (_openBlock(), _createBlock(_component_el_input, {
                                                key: 1,
                                                size: "mini",
                                                modelValue: item.pass_text,
                                                "onUpdate:modelValue": ($event: any) => (item.pass_text = $event)
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createVNode("td", _hoisted_28, [
                                        (_ctx.configurationShow)
                                          ? (_openBlock(), _createBlock("span", _hoisted_29, _toDisplayString(item.no_pass_text), 1))
                                          : _createCommentVNode("", true),
                                        (!_ctx.configurationShow)
                                          ? (_openBlock(), _createBlock(_component_el_input, {
                                              key: 1,
                                              size: "mini",
                                              modelValue: item.no_pass_text,
                                              "onUpdate:modelValue": ($event: any) => (item.no_pass_text = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128)),
                            _createVNode("div", null, [
                              _hoisted_30,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.baseline_data_fps, (item) => {
                                return (_openBlock(), _createBlock("div", { key: item }, [
                                  _createVNode(_component_el_table, {
                                    border: "",
                                    size: "mini",
                                    "header-cell-style": {
                        background: '#5D99D5',
                        color: '#fff',
                      },
                                    "span-method": _ctx.cellMerge,
                                    data: item
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_table_column, {
                                        label: "平台",
                                        prop: "name"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "机型挡位",
                                        prop: "module"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "AvgFPS",
                                        prop: "name"
                                      }, {
                                        default: _withId((scope) => [
                                          (_ctx.configurationShow)
                                            ? (_openBlock(), _createBlock("span", _hoisted_31, _toDisplayString(scope.row.avgFps), 1))
                                            : _createCommentVNode("", true),
                                          (!_ctx.configurationShow)
                                            ? (_openBlock(), _createBlock(_component_el_input, {
                                                key: 1,
                                                size: "mini",
                                                modelValue: scope.row.avgFps,
                                                "onUpdate:modelValue": ($event: any) => (scope.row.avgFps = $event)
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "MaxPSS(MB)",
                                        prop: "name"
                                      }, {
                                        default: _withId((scope) => [
                                          (_ctx.configurationShow)
                                            ? (_openBlock(), _createBlock("span", _hoisted_32, _toDisplayString(scope.row.maxPss), 1))
                                            : _createCommentVNode("", true),
                                          (!_ctx.configurationShow)
                                            ? (_openBlock(), _createBlock(_component_el_input, {
                                                key: 1,
                                                size: "mini",
                                                modelValue: scope.row.maxPss,
                                                "onUpdate:modelValue": ($event: any) => (scope.row.maxPss = $event)
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "温度",
                                        prop: "name"
                                      }, {
                                        default: _withId((scope) => [
                                          (_ctx.configurationShow)
                                            ? (_openBlock(), _createBlock("span", _hoisted_33, _toDisplayString(scope.row["最高温度"]), 1))
                                            : _createCommentVNode("", true),
                                          (!_ctx.configurationShow)
                                            ? (_openBlock(), _createBlock(_component_el_input, {
                                                key: 1,
                                                size: "mini",
                                                modelValue: scope.row['最高温度'],
                                                "onUpdate:modelValue": ($event: any) => (scope.row['最高温度'] = $event)
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["span-method", "data"])
                                ]))
                              }), 128))
                            ]),
                            _createVNode("div", null, [
                              _hoisted_34,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.baseline_data_Picture, (item) => {
                                return (_openBlock(), _createBlock("div", { key: item }, [
                                  _createVNode(_component_el_table, {
                                    border: "",
                                    size: "mini",
                                    "header-cell-style": {
                        background: '#5D99D5',
                        color: '#fff',
                      },
                                    "span-method": _ctx.cellMerge,
                                    data: item
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_table_column, {
                                        label: "平台",
                                        prop: "name"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "画质",
                                        prop: "module"
                                      }, {
                                        default: _withId((scope) => [
                                          (_ctx.configurationShow)
                                            ? (_openBlock(), _createBlock("span", _hoisted_35, _toDisplayString(scope.row.module), 1))
                                            : _createCommentVNode("", true),
                                          (!_ctx.configurationShow)
                                            ? (_openBlock(), _createBlock(_component_el_input, {
                                                key: 1,
                                                size: "mini",
                                                modelValue: scope.row.module,
                                                "onUpdate:modelValue": ($event: any) => (scope.row.module = $event)
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "MaxPSS(MB)",
                                        prop: "name"
                                      }, {
                                        default: _withId((scope) => [
                                          (_ctx.configurationShow)
                                            ? (_openBlock(), _createBlock("span", _hoisted_36, _toDisplayString(scope.row.maxPss), 1))
                                            : _createCommentVNode("", true),
                                          (!_ctx.configurationShow)
                                            ? (_openBlock(), _createBlock(_component_el_input, {
                                                key: 1,
                                                size: "mini",
                                                modelValue: scope.row.maxPss,
                                                "onUpdate:modelValue": ($event: any) => (scope.row.maxPss = $event)
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["span-method", "data"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tab_pane, {
                      label: "问题汇总",
                      disabled: false,
                      name: "thread"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_card, null, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_37, [
                              _createVNode("div", {
                                onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.UploadProblem('open'))),
                                style: {"font-size":"14px","color":"#409eff","widht":"100%","margin-right":"10px","cursor":"pointer"}
                              }, " 文件上传 "),
                              (_ctx.formTableData.get('file') != null)
                                ? (_openBlock(), _createBlock("div", {
                                    key: 0,
                                    onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.downloadCsv1 && _ctx.downloadCsv1(...args))),
                                    style: {"font-size":"14px","color":"#409eff","widht":"100%","cursor":"pointer"}
                                  }, " 导出问题汇总 "))
                                : (_openBlock(), _createBlock("div", _hoisted_38, " 导出问题汇总 "))
                            ]),
                            _createVNode(_component_el_card, { class: "spacName" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_checkbox, {
                                  modelValue: _ctx.checkAll,
                                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.checkAll = $event)),
                                  indeterminate: _ctx.isIndeterminate,
                                  onChange: _ctx.handleCheckAllChange
                                }, {
                                  default: _withId(() => [
                                    _hoisted_39
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "indeterminate", "onChange"]),
                                _createVNode(_component_el_checkbox_group, {
                                  modelValue: _ctx.checkedCities,
                                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.checkedCities = $event)),
                                  onChange: _ctx.handleCheckedCitiesChange
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_row, null, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.messagesList_thead, (city) => {
                                          return (_openBlock(), _createBlock(_component_el_col, {
                                            key: city,
                                            span: 2
                                          }, {
                                            default: _withId(() => [
                                              _createVNode(_component_el_checkbox, { label: city }, {
                                                default: _withId(() => [
                                                  _createTextVNode(_toDisplayString(city), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["label"])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "onChange"]),
                                _createVNode(_component_el_divider),
                                _createVNode("div", _hoisted_40, [
                                  _createVNode(_component_el_dialog, {
                                    modelValue: _ctx.dialogVisible1,
                                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.dialogVisible1 = $event)),
                                    width: "30%",
                                    onClose: _cache[43] || (_cache[43] = ($event: any) => (_ctx.dialogVisible1 = false))
                                  }, {
                                    title: _withId(() => [
                                      _createVNode("div", _hoisted_41, [
                                        _hoisted_42,
                                        _createVNode(_component_el_divider)
                                      ])
                                    ]),
                                    footer: _withId(() => [
                                      _createVNode("span", _hoisted_46, [
                                        _createVNode(_component_el_button, {
                                          size: "small",
                                          onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.UploadProblem('no')))
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_47
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_button, {
                                          size: "small",
                                          type: "primary",
                                          onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.UploadProblem('ok')))
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_48
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    default: _withId(() => [
                                      _createVNode(_component_el_form, {
                                        model: _ctx.dialogForm,
                                        size: "small",
                                        "label-position": "top"
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_form_item, { label: "基线列表" }, {
                                            default: _withId(() => [
                                              _createVNode(_component_el_select, {
                                                onChange: _cache[38] || (_cache[38] = ($event: any) => (_ctx.lineChange())),
                                                modelValue: _ctx.basic_value,
                                                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_ctx.basic_value = $event)),
                                                placeholder: "请选择",
                                                clearable: ""
                                              }, {
                                                default: _withId(() => [
                                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.top_base_list, (item) => {
                                                    return (_openBlock(), _createBlock(_component_el_option, {
                                                      key: item.id,
                                                      label: item.project_name,
                                                      value: item.id
                                                    }, null, 8, ["label", "value"]))
                                                  }), 128))
                                                ]),
                                                _: 1
                                              }, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_form_item, { label: "上传文件" }, {
                                            default: _withId(() => [
                                              _createVNode(_component_el_upload, {
                                                class: "upload-demo",
                                                drag: "",
                                                action: "http://127.0.0.1:8081/api/v1/performance/top_upload/",
                                                multiple: "",
                                                limit: 1,
                                                "before-upload": _ctx.beforeUploadTop,
                                                ref: 'uploadTop',
                                                "http-request": _ctx.UploadFileTop
                                              }, {
                                                tip: _withId(() => [
                                                  _hoisted_45
                                                ]),
                                                default: _withId(() => [
                                                  _hoisted_43,
                                                  _hoisted_44
                                                ]),
                                                _: 1
                                              }, 8, ["before-upload", "http-request"]),
                                              (_ctx.progressFlag)
                                                ? (_openBlock(), _createBlock(_component_el_progress, {
                                                    key: 0,
                                                    percentage: _ctx.loadProgress
                                                  }, null, 8, ["percentage"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["model"])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _createVNode("div", _hoisted_49, [
                                  _createVNode(_component_el_dialog, {
                                    modelValue: _ctx.dialogVisible3,
                                    "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (_ctx.dialogVisible3 = $event)),
                                    width: "30%",
                                    onClose: _cache[49] || (_cache[49] = ($event: any) => (_ctx.dialogVisible3 = false)),
                                    style: {"padding":"0"}
                                  }, {
                                    title: _withId(() => [
                                      _hoisted_50
                                    ]),
                                    footer: _withId(() => [
                                      _createVNode("span", _hoisted_51, [
                                        _createVNode(_component_el_button, {
                                          size: "small",
                                          onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.dialogVisible3 = false))
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_52
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_button, {
                                          size: "small",
                                          type: "primary",
                                          onClick: _ctx.htmlBtn
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_53
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ])
                                    ]),
                                    default: _withId(() => [
                                      _createVNode(_component_el_form, {
                                        size: "small",
                                        inline: true,
                                        "label-position": "top"
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_form_item, { label: "选择提单方式" }, {
                                            default: _withId(() => [
                                              _createVNode(_component_el_select, {
                                                onChange: _ctx.problemChange,
                                                modelValue: _ctx.form_problem,
                                                "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_ctx.form_problem = $event)),
                                                placeholder: "请选择"
                                              }, {
                                                default: _withId(() => [
                                                  _createVNode(_component_el_option_group, null, {
                                                    default: _withId(() => [
                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.problem_option, (item) => {
                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                          key: item,
                                                          label: item,
                                                          value: item
                                                        }, null, 8, ["label", "value"]))
                                                      }), 128))
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }, 8, ["onChange", "modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_form_item, { label: "选择模板" }, {
                                            default: _withId(() => [
                                              _createVNode(_component_el_select, {
                                                onChange: _cache[45] || (_cache[45] = ($event: any) => (_ctx.moduleChange())),
                                                modelValue: _ctx.basic_form.value,
                                                "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (_ctx.basic_form.value = $event)),
                                                placeholder: "请选择",
                                                clearable: ""
                                              }, {
                                                default: _withId(() => [
                                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.top_temp_list, (item) => {
                                                    return (_openBlock(), _createBlock(_component_el_option, {
                                                      key: item.id,
                                                      label: item.name,
                                                      value: item.id
                                                    }, null, 8, ["label", "value"]))
                                                  }), 128))
                                                ]),
                                                _: 1
                                              }, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]),
                                  _createVNode(_component_el_dialog, {
                                    modelValue: _ctx.dialogVisible6,
                                    "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => (_ctx.dialogVisible6 = $event)),
                                    width: "30%",
                                    onClose: _cache[55] || (_cache[55] = ($event: any) => (_ctx.dialogVisible6 = false)),
                                    style: {"padding":"0"}
                                  }, {
                                    title: _withId(() => [
                                      _hoisted_54
                                    ]),
                                    footer: _withId(() => [
                                      _createVNode("span", _hoisted_55, [
                                        _createVNode(_component_el_button, {
                                          size: "small",
                                          onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.dialogVisible6 = false))
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_56
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_button, {
                                          size: "small",
                                          type: "primary",
                                          onClick: _ctx.htmlAllBtn
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_57
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ])
                                    ]),
                                    default: _withId(() => [
                                      _createVNode(_component_el_form, {
                                        size: "small",
                                        inline: true,
                                        "label-position": "top"
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_form_item, { label: "选择提单方式" }, {
                                            default: _withId(() => [
                                              _createVNode(_component_el_select, {
                                                onChange: _ctx.problemChange,
                                                modelValue: _ctx.form_problem,
                                                "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (_ctx.form_problem = $event)),
                                                placeholder: "请选择"
                                              }, {
                                                default: _withId(() => [
                                                  _createVNode(_component_el_option_group, null, {
                                                    default: _withId(() => [
                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.problem_option, (item) => {
                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                          key: item,
                                                          label: item,
                                                          value: item
                                                        }, null, 8, ["label", "value"]))
                                                      }), 128))
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }, 8, ["onChange", "modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_form_item, { label: "选择模板" }, {
                                            default: _withId(() => [
                                              _createVNode(_component_el_select, {
                                                onChange: _cache[51] || (_cache[51] = ($event: any) => (_ctx.moduleChange())),
                                                modelValue: _ctx.basic_form.value,
                                                "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (_ctx.basic_form.value = $event)),
                                                placeholder: "请选择",
                                                clearable: ""
                                              }, {
                                                default: _withId(() => [
                                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.top_temp_list, (item) => {
                                                    return (_openBlock(), _createBlock(_component_el_option, {
                                                      key: item.id,
                                                      label: item.name,
                                                      value: item.id
                                                    }, null, 8, ["label", "value"]))
                                                  }), 128))
                                                ]),
                                                _: 1
                                              }, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _createVNode(_component_el_table, {
                                  size: "mini",
                                  "header-cell-style": {
                      background: '#5D99D5',
                      color: '#fff',
                    },
                                  data: 
                      _ctx.problemData.slice(
                        (_ctx.courseCurrentPage - 1) * _ctx.courseSize,
                        _ctx.courseCurrentPage * _ctx.courseSize
                      )
                    
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.problemList, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_table_column, {
                                        key: item,
                                        label: item,
                                        prop: item
                                      }, null, 8, ["label", "prop"]))
                                    }), 128)),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.checkedCities, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_table_column, {
                                        key: item,
                                        label: item,
                                        prop: item
                                      }, null, 8, ["label", "prop"]))
                                    }), 128)),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.problemListEdit, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_table_column, {
                                        key: item,
                                        label: item,
                                        width: "200",
                                        align: "center"
                                      }, {
                                        default: _withId((scope) => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(scope.row[item].res, (v, index) => {
                                            return (_openBlock(), _createBlock("div", {
                                              key: index,
                                              class: "problem_list"
                                            }, [
                                              _createVNode("span", null, _toDisplayString(index + 1) + "、", 1),
                                              (_ctx.editText(item, index, scope.$index, 'text'))
                                                ? (_openBlock(), _createBlock("span", {
                                                    key: 0,
                                                    onClick: ($event: any) => (_ctx.editOpen(item, index, scope.$index))
                                                  }, _toDisplayString(v), 9, ["onClick"]))
                                                : _createCommentVNode("", true),
                                              (_ctx.editText(item, index, scope.$index, 'btn'))
                                                ? (_openBlock(), _createBlock(_component_el_input, {
                                                    key: 1,
                                                    onChange: _cache[56] || (_cache[56] = ($event: any) => (_ctx.inputChange(''))),
                                                    onBlur: _cache[57] || (_cache[57] = ($event: any) => (_ctx.inputBlur())),
                                                    size: "mini",
                                                    modelValue: scope.row[item].res[index],
                                                    "onUpdate:modelValue": ($event: any) => (scope.row[item].res[index] = $event)
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["label"]))
                                    }), 128)),
                                    _createVNode(_component_el_table_column, {
                                      width: "120",
                                      fixed: "right",
                                      align: "center"
                                    }, {
                                      default: _withId((scope) => [
                                        _createVNode(_component_el_button, {
                                          size: "mini",
                                          type: "primary",
                                          onClick: ($event: any) => (_ctx.submitUnit(scope.row))
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_58
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "提单状态",
                                      width: "120",
                                      fixed: "right",
                                      align: "center"
                                    }, {
                                      default: _withId((scope) => [
                                        (scope.row['提单状态'] == 0)
                                          ? (_openBlock(), _createBlock("span", _hoisted_59, "未提单"))
                                          : (_openBlock(), _createBlock("span", _hoisted_60, "已提单"))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["data"]),
                                _createVNode("div", _hoisted_61, [
                                  _createVNode(_component_el_form, {
                                    style: {"display":"flex","align-items":"center"},
                                    inline: true,
                                    size: "mini"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_form_item, null, {
                                        default: _withId(() => [
                                          _createVNode("a", {
                                            style: {"color":"rgb(64, 158, 255)","cursor":"pointer"},
                                            onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.dialogVisible6 = true))
                                          }, "全部提单")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_form_item, {
                                        style: {"margin-bottom":"0"},
                                        label: "每页"
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_input, {
                                            modelValue: _ctx.courseSize,
                                            "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => (_ctx.courseSize = $event)),
                                            style: {"width":"55px","height":"28px"}
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_form_item, {
                                        style: {"margin-bottom":"0"},
                                        label: "条记录"
                                      }),
                                      _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_pagination, {
                                            currentPage: _ctx.courseCurrentPage,
                                            "onUpdate:currentPage": _cache[60] || (_cache[60] = ($event: any) => (_ctx.courseCurrentPage = $event)),
                                            "page-size": _ctx.courseSize,
                                            style: {"text-align":"right"},
                                            total: _ctx.problemData?.length,
                                            layout: "total, prev, pager, next,jumper"
                                          }, null, 8, ["currentPage", "page-size", "total"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tab_pane, {
                      style: {"width":"50%；margin:auto"},
                      label: "提单模板",
                      disabled: false,
                      name: "fourth"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_card, null, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_62, [
                              _createVNode(_component_el_form, {
                                class: "top_form",
                                "label-position": "left",
                                "label-width": "100px",
                                model: _ctx.basic_form,
                                size: "mini"
                              }, {
                                default: _withId(() => [
                                  _createVNode("div", _hoisted_63, [
                                    _createVNode(_component_el_form_item, { label: "模板列表" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          onChange: _cache[61] || (_cache[61] = ($event: any) => (_ctx.moduleChange())),
                                          modelValue: _ctx.basic_form.value,
                                          "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => (_ctx.basic_form.value = $event)),
                                          placeholder: "请选择",
                                          clearable: ""
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.top_temp_list, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.id,
                                                label: item.name,
                                                value: item.id
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_button, {
                                          type: _ctx.htmlShow ? 'primary' : 'success',
                                          style: {"margin-left":"10px"},
                                          onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.editHtml()))
                                        }, {
                                          default: _withId(() => [
                                            _createTextVNode(_toDisplayString(_ctx.btn_name), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["type"]),
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          onClick: _ctx.creatBtn
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_64
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]),
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          onClick: _ctx.htmlDefault
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_65
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode(_component_el_form_item, { label: "模板名称" }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.basic_form.name,
                                        "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => (_ctx.basic_form.name = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, { label: "项目名称" }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.basic_form.title,
                                        "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => (_ctx.basic_form.title = $event)),
                                        disabled: _ctx.htmlShow
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, { label: "处理人" }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.basic_form.processed_by,
                                        "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => (_ctx.basic_form.processed_by = $event)),
                                        disabled: _ctx.htmlShow
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, { label: "发现版本" }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.basic_form.discovered_version,
                                        "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => (_ctx.basic_form.discovered_version = $event)),
                                        disabled: _ctx.htmlShow
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, { label: "严重程度 " }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_select, {
                                        disabled: _ctx.htmlShow,
                                        modelValue: _ctx.basic_form.degree,
                                        "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => (_ctx.basic_form.degree = $event)),
                                        placeholder: "请选择",
                                        clearable: ""
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.degree, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.value,
                                              label: item.name,
                                              value: item.value
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["disabled", "modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, { label: "发现阶段" }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.basic_form.discovery_phase,
                                        "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => (_ctx.basic_form.discovery_phase = $event)),
                                        disabled: _ctx.htmlShow
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["model"])
                            ]),
                            _createVNode("div", _hoisted_66, [
                              (!_ctx.htmlShow)
                                ? (_openBlock(), _createBlock(_component_QuillEditor, {
                                    key: 0,
                                    content: _ctx.htmlValue,
                                    "onUpdate:content": _cache[70] || (_cache[70] = ($event: any) => (_ctx.htmlValue = $event)),
                                    contentType: "html",
                                    options: _ctx.editorOption,
                                    theme: "snow"
                                  }, null, 8, ["content", "options"]))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.htmlShow)
                              ? (_openBlock(), _createBlock(_component_el_card, {
                                  key: 0,
                                  style: {"margin":"20px 0"}
                                }, {
                                  default: _withId(() => [
                                    _createVNode("div", { innerHTML: _ctx.htmlValue }, null, 8, ["innerHTML"]),
                                    false
                                      ? (_openBlock(), _createBlock("div", {
                                          key: 0,
                                          innerHTML: _ctx.htmlValue2
                                        }, null, 8, ["innerHTML"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tab_pane, {
                      style: {"width":"50%；margin:auto"},
                      label: "数据汇总",
                      disabled: false,
                      name: "fifth"
                    }, {
                      default: _withId(() => [
                        _createVNode("span", {
                          onClick: _cache[71] || (_cache[71] = ($event: any) => (_ctx.handleAddScriptV2())),
                          style: {"font-size":"14px","color":"#409eff","widht":"100%","cursor":"pointer"}
                        }, "数据上传"),
                        _createVNode(_component_el_card, { class: "script" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form, {
                              class: "spacForm",
                              size: "mini",
                              inline: true
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "选择项目",
                                  prop: "script_scene",
                                  style: {"width":"160px"}
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.top_project_old,
                                      "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => (_ctx.top_project_old = $event)),
                                      filterable: "",
                                      clearable: "",
                                      placeholder: "请选择项目",
                                      onChange: _ctx.topChange
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.topProjectScenes, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.id,
                                            label: item.project_name,
                                            value: item.id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "onChange"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "选择设备" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.top_project,
                                      "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => (_ctx.top_project = $event)),
                                      placeholder: "请选择设备",
                                      clearable: "",
                                      filterable: "",
                                      onChange: _ctx.topChange
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.topDataList.model_list, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.model_name,
                                            label: item.model_name,
                                            value: item.model_name
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "onChange"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "选择版本" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.top_version,
                                      "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => (_ctx.top_version = $event)),
                                      placeholder: "请选择版本",
                                      clearable: "",
                                      filterable: "",
                                      onChange: _ctx.topChange
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_option_group, null, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.topDataList.version_list, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.version,
                                                label: item.version,
                                                value: item.version
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "onChange"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_dialog, {
                              width: "615px",
                              onClose: _ctx.closeAddScript,
                              modelValue: _ctx.addScript,
                              "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => (_ctx.addScript = $event))
                            }, {
                              title: _withId(() => [
                                _createVNode("div", _hoisted_67, [
                                  _hoisted_68,
                                  _createVNode(_component_el_divider)
                                ])
                              ]),
                              footer: _withId(() => [
                                _createVNode("span", _hoisted_69, [
                                  _createVNode(_component_el_button, {
                                    size: "small",
                                    onClick: _ctx.closeAddScript,
                                    type: "info"
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_70
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]),
                                  _createVNode(_component_el_button, {
                                    size: "small",
                                    type: "primary",
                                    onClick: _ctx.addAddScript
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_71
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ])
                              ]),
                              default: _withId(() => [
                                _createVNode(_component_el_form, {
                                  class: "top_dialog",
                                  inline: true,
                                  "label-position": "top",
                                  size: "small"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_form_item, {
                                      label: "游戏名称",
                                      size: "small",
                                      prop: "original_scene_id"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          placeholder: "请输入游戏名称",
                                          modelValue: _ctx.addScriptForm.chinese,
                                          "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => (_ctx.addScriptForm.chinese = $event)),
                                          autocomplete: "off"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "游戏英文名称",
                                      size: "small",
                                      prop: "original_scene_id"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          placeholder: "请输入游戏英文名称",
                                          modelValue: _ctx.addScriptForm.project_key,
                                          "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => (_ctx.addScriptForm.project_key = $event)),
                                          autocomplete: "off"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "开发团队",
                                      size: "small",
                                      prop: "original_scene_id"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          placeholder: "请输入开发团队",
                                          modelValue: _ctx.addScriptForm.team,
                                          "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => (_ctx.addScriptForm.team = $event)),
                                          autocomplete: "off"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "游戏种类",
                                      size: "small"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.addScriptForm.game,
                                          "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => (_ctx.addScriptForm.game = $event)),
                                          placeholder: "请选择",
                                          clearable: "",
                                          filterable: ""
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gameTypeList, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.value,
                                                label: item.label,
                                                value: item.value
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "数据分类",
                                      size: "small"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.addScriptForm.data,
                                          "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => (_ctx.addScriptForm.data = $event)),
                                          placeholder: "请选择",
                                          clearable: "",
                                          filterable: ""
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataTypeList, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.value,
                                                label: item.label,
                                                value: item.value
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["onClose", "modelValue"]),
                            _createVNode(_component_el_dialog, {
                              onClose: _ctx.closeBtn,
                              width: "90%",
                              modelValue: _ctx.peload_show,
                              "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => (_ctx.peload_show = $event))
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table, {
                                  data: _ctx.get_top_performance_advance.results,
                                  ref: "dataTable",
                                  "header-cell-class-name": "tabelHeader"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_table_column, {
                                      index: _ctx.indexMethod2(0),
                                      type: "index",
                                      label: "序号",
                                      width: "60"
                                    }, null, 8, ["index"]),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.upload_thead, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_el_table_column, {
                                        key: item.label,
                                        index: index,
                                        width: item.width,
                                        label: item.lable,
                                        prop: item.value,
                                        title: item.prop,
                                        "show-overflow-tooltip": true
                                      }, {
                                        default: _withId((scope) => [
                                          (item.value != 'url')
                                            ? (_openBlock(), _createBlock("span", _hoisted_72, _toDisplayString(scope.row[item.value] ? scope.row[item.value] : "-"), 1))
                                            : (_openBlock(), _createBlock("span", _hoisted_73, [
                                                _createVNode("a", {
                                                  target: "_blank",
                                                  href: scope.row[item.value]
                                                }, "链接", 8, ["href"])
                                              ]))
                                        ]),
                                        _: 2
                                      }, 1032, ["index", "width", "label", "prop", "title"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["data"]),
                                _createVNode("div", _hoisted_74, [
                                  _createVNode(_component_el_form, {
                                    style: {"display":"flex","align-items":"center"},
                                    inline: true,
                                    size: "mini"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_form_item, {
                                        style: {"margin-bottom":"0"},
                                        label: "每页"
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_input, {
                                            modelValue: _ctx.peload_size,
                                            "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => (_ctx.peload_size = $event)),
                                            style: {"width":"55px","height":"28px"},
                                            onChange: _cache[82] || (_cache[82] = ($event: any) => (_ctx.peloadChange_top('paging')))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_form_item, {
                                        style: {"margin-bottom":"0"},
                                        label: "条记录"
                                      }),
                                      _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_pagination, {
                                            onCurrentChange: _cache[83] || (_cache[83] = ($event: any) => (_ctx.peloadChange_top())),
                                            currentPage: _ctx.peload_currentPage,
                                            "onUpdate:currentPage": _cache[84] || (_cache[84] = ($event: any) => (_ctx.peload_currentPage = $event)),
                                            "page-size": _ctx.peload_size,
                                            style: {"text-align":"right"},
                                            total: _ctx.get_top_performance_advance.count,
                                            layout: "total, prev, pager, next,jumper"
                                          }, null, 8, ["currentPage", "page-size", "total"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_button, {
                                            type: "primary",
                                            onClick: _ctx.save_btn
                                          }, {
                                            default: _withId(() => [
                                              _hoisted_75
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["onClose", "modelValue"]),
                            _createVNode(_component_el_dialog, {
                              width: "615px",
                              onClose: _cache[90] || (_cache[90] = ($event: any) => (_ctx.resetAddForm('ruleaddForm'))),
                              modelValue: _ctx.dialogAddFormVisible,
                              "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => (_ctx.dialogAddFormVisible = $event))
                            }, {
                              title: _withId(() => [
                                _createVNode("div", _hoisted_76, [
                                  _hoisted_77,
                                  _createVNode(_component_el_divider)
                                ])
                              ]),
                              footer: _withId(() => [
                                _createVNode("span", _hoisted_81, [
                                  _createVNode(_component_el_button, {
                                    size: "small",
                                    onClick: _cache[88] || (_cache[88] = ($event: any) => (_ctx.resetAddForm('ruleaddForm'))),
                                    type: "info"
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_82
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_button, {
                                    size: "small",
                                    type: "primary",
                                    onClick: _cache[89] || (_cache[89] = ($event: any) => (_ctx.submitAddForm()))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_83
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              default: _withId(() => [
                                _createVNode(_component_el_form, {
                                  model: _ctx.addForm,
                                  inline: true,
                                  "label-position": "top",
                                  ref: "ruleaddForm",
                                  style: {"justify-content":"space-around"},
                                  size: "small"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_form_item, {
                                      label: "项目",
                                      prop: "script_scene",
                                      style: {"width":"160px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.filterScript,
                                          "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => (_ctx.filterScript = $event)),
                                          filterable: "",
                                          clearable: "",
                                          placeholder: "请选择项目"
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.topProjectScenes, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.id,
                                                label: item.project_name,
                                                value: item.id
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"]),
                                        _createVNode(_component_el_button, {
                                          onClick: _ctx.openAddScript,
                                          style: {"color":"#c0c4cc"}
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_78
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "版本",
                                      style: {"width":"160px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.topProjectVersion,
                                          "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => (_ctx.topProjectVersion = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "数据文件",
                                      prop: "script_id",
                                      align: "center"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_upload, {
                                          class: "upload-demo uploadBox",
                                          action: "http://127.0.0.1:8080/api/v1/top/top_list/",
                                          limit: 1,
                                          "http-request": _ctx.ploadImage,
                                          "on-remove": _ctx.ploadImage,
                                          style: {"color":"#c0c4cc","border":"1px solid #dcdfe6","border-radius":"4px","height":"32px","width":"160px","position":"relative"},
                                          ref: 'upload'
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_79,
                                            _hoisted_80
                                          ]),
                                          _: 1
                                        }, 8, ["http-request", "on-remove"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["model"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_el_table, {
                              data: _ctx.get_top_performance.results,
                              ref: "dataTable",
                              "header-cell-class-name": "tabelHeader"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table_column, {
                                  index: _ctx.indexMethod1(0),
                                  type: "index",
                                  label: "序号",
                                  width: "60"
                                }, null, 8, ["index"]),
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.upload_thead, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: item.label,
                                    index: index,
                                    width: item.width,
                                    label: item.lable,
                                    prop: item.value,
                                    title: item.prop,
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withId((scope) => [
                                      (item.value != 'url')
                                        ? (_openBlock(), _createBlock("span", _hoisted_84, _toDisplayString(scope.row[item.value] ? scope.row[item.value] : "-"), 1))
                                        : (_openBlock(), _createBlock("span", _hoisted_85, [
                                            _createVNode("a", {
                                              target: "_blank",
                                              href: scope.row[item.value]
                                            }, "链接", 8, ["href"])
                                          ]))
                                    ]),
                                    _: 2
                                  }, 1032, ["index", "width", "label", "prop", "title"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["data"]),
                            _createVNode("div", _hoisted_86, [
                              _createVNode(_component_el_form, {
                                style: {"display":"flex","align-items":"center"},
                                inline: true,
                                size: "mini"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_form_item, {
                                    style: {"margin-bottom":"0"},
                                    label: "每页"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.top_size,
                                        "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => (_ctx.top_size = $event)),
                                        style: {"width":"55px","height":"28px"},
                                        onChange: _cache[93] || (_cache[93] = ($event: any) => (_ctx.selectTableChange_top('paging')))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, {
                                    style: {"margin-bottom":"0"},
                                    label: "条记录"
                                  }),
                                  _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_pagination, {
                                        onCurrentChange: _cache[94] || (_cache[94] = ($event: any) => (_ctx.selectTableChange_top('paging'))),
                                        currentPage: _ctx.courseCurrentPage_top,
                                        "onUpdate:currentPage": _cache[95] || (_cache[95] = ($event: any) => (_ctx.courseCurrentPage_top = $event)),
                                        "page-size": _ctx.top_size,
                                        style: {"text-align":"right"},
                                        total: _ctx.get_top_performance.count,
                                        layout: "total, prev, pager, next,jumper"
                                      }, null, 8, ["currentPage", "page-size", "total"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onTabClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})